
import {Component, Prop, Vue} from 'vue-facing-decorator'

@Component
export default class DocView extends Vue {
  @Prop({type: String, required: true}) readonly url!: string
  @Prop({type: String, default: ''}) readonly title!: string

  text = ''
  loading = false
  error = ''

  async mounted() {
    this.loading = true
    this.error = ''
    try {
      const response = await fetch(this.url)
      if (!response.ok) throw new Error(`HTTP ${response.status}`)
      this.text = await response.text()
    } catch (e) {
      this.error = 'Не удалось загрузить документ'
    } finally {
      this.loading = false
    }
  }

  onClose() {
    this.$emit('close')
  }
}
